import React from "react";

export function PlusIcon() {
  return (
    <div>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="plus-icon"
        style={{ width: "12px", height: "12px" }}
      >
        <g clipPath="url(#clip0_2019_878)">
          <path
            d="M1.26367 6.00003H10.7374M6.00051 1.26318V10.7369"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_2019_878">
            <rect width="12" height="12" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export function CallIcon() {
  return (
    <div>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="call-icon"
        style={{ width: "12px", height: "12px" }}
      >
        <g clipPath="url(#clip0_2019_165)">
          <path
            d="M5.08602 4.87085L4.73244 4.51733L4.73247 4.51729C5.2849 3.96488 5.3963 3.17273 5.07834 2.60299L5.07834 2.60299L4.59159 1.7308C4.11853 0.883168 2.86021 0.703179 2.00691 1.55648L2.00691 1.55648C1.42026 2.14312 1.02994 2.79912 1.00456 3.46876L0.504914 3.44982L1.00456 3.46876C0.954668 4.78466 1.28054 7.07186 3.60433 9.39567C5.92814 11.7195 8.21535 12.0453 9.53121 11.9954L9.53126 11.9954C10.2009 11.9701 10.8569 11.5798 11.4435 10.9931C11.4435 10.9931 11.4435 10.9931 11.4435 10.9931M5.08602 4.87085L11.5128 7.9718C12.7014 8.6351 12.8418 10.3019 11.7971 11.3467L11.4435 10.9931M5.08602 4.87085C4.73244 4.51733 4.73213 4.51764 4.73181 4.51796L4.73115 4.51862L4.72978 4.52001L4.72679 4.52306L4.7199 4.53027C4.71491 4.53555 4.70914 4.54183 4.70271 4.5491C4.68985 4.56361 4.67426 4.58215 4.65688 4.6047C4.62221 4.6497 4.57988 4.71139 4.53796 4.78962C4.45367 4.94693 4.37121 5.17115 4.35725 5.4562C4.32861 6.04087 4.59015 6.76047 5.41481 7.58517L5.41482 7.58518C6.23931 8.40967 6.95889 8.67113 7.54352 8.64258C7.82855 8.62866 8.05278 8.54629 8.21011 8.46208C8.28835 8.4202 8.35006 8.37791 8.39507 8.34326C8.41762 8.3259 8.43617 8.31032 8.45068 8.29747C8.45795 8.29105 8.46423 8.28528 8.46952 8.2803L8.47672 8.27341L8.47978 8.27043L8.48117 8.26906L8.48183 8.2684C8.48215 8.26808 8.48246 8.26777 8.12915 7.91398M5.08602 4.87085L8.12915 7.91398M11.4435 10.9931C12.2968 10.1397 12.1168 8.88144 11.2692 8.40842L11.2692 8.40841L10.397 7.92166C9.82726 7.6037 9.03513 7.7151 8.4827 8.26753L8.48246 8.26777L8.12915 7.91398M11.4435 10.9931L8.12915 7.91398"
            stroke="#323232"
            strokeOpacity="0.8"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_2019_165">
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(0.5 0.5)"
            ></rect>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export function EmailIcon() {
  return (
    <div>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="email-icon"
        style={{ width: "12px", height: "12px" }}
      >
        <g clipPath="url(#clip0_2019_169)">
          <path
            d="M13.1673 2.125V4.625L6.50065 7.125L-0.166016 4.625V2.125C-0.166016 1.95924 -0.0957778 1.80027 0.0292465 1.68306C0.154271 1.56585 0.32384 1.5 0.500651 1.5H12.5007C12.6775 1.5 12.847 1.56585 12.9721 1.68306C13.0971 1.80027 13.1673 1.95924 13.1673 2.125ZM-0.166016 5.97125V10.875C-0.166016 11.0408 -0.0957778 11.1997 0.0292465 11.3169C0.154271 11.4342 0.32384 11.5 0.500651 11.5H12.5007C12.6775 11.5 12.847 11.4342 12.9721 11.3169C13.0971 11.1997 13.1673 11.0408 13.1673 10.875V5.97125L6.50065 8.47125L-0.166016 5.97125Z"
            fill="#323232"
            fillOpacity="0.8"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_2019_169">
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(0.5 0.5)"
            ></rect>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

interface ProfileImageProps {
  boxSize?: string;
  flexShrink?: number;
  [key: string]: any;
}

export function ProfileImage(props: ProfileImageProps) {
  const { boxSize = "28px", flexShrink = 0, firstLetter, ...rest } = props;
  return (
    <div style={{ width: boxSize, height: boxSize, flexShrink }} {...rest}>
      <svg
        width={boxSize}
        height={boxSize}
        viewBox="0 0 28 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="profile-img"
        style={{ width: "100%", height: "100%" }}
      >
        <circle cx="14" cy="14.5" r="14" fill="#1A9882"></circle>
        <text
          x="14"
          y="18.5"
          fontFamily="Arial"
          fontSize="14"
          fill="white"
          textAnchor="middle"
          dominantBaseline="middle"
        >
            {firstLetter?.toUpperCase()}
        </text>
      </svg>
    </div>
  );
} 